class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const target = new Date(`${this.dataset.date}T${this.dataset.time || '00:00'}:00`);
    if (Number.isNaN(target.getTime())) return;
    this.target = target;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  tick() {
    const diff = this.target.getTime() - Date.now();
    if (diff <= 0) {
      this.hidden = true;
      clearInterval(this.timer);
      return;
    }
    this.hidden = false;
    const s = Math.floor(diff / 1000);
    const parts = { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
    Object.entries(parts).forEach(([key, value]) => {
      const el = this.querySelector(`[data-${key}]`);
      if (el) el.textContent = String(value).padStart(2, '0');
    });
  }
}
if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
